<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: true; size?: string; color?: string }>(), {
  filled: true,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v4H4V6Z"
    />
  </svg>
</template>
